module.exports = __webpack_public_path__ + "static/media/07.8cf9db88.jpg";